import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InventoryIcon from '@mui/icons-material/Inventory2';

const ProductVariationList = ({ variations, onEditVariation, onDeleteVariation }) => {
  return (
    <TableContainer component={Paper} sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2 }}>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <InventoryIcon color="primary" />
        <Typography variant="h6" fontWeight={600} color="text.primary">
          Product Variations
        </Typography>
      </Box>

      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Attribute</strong></TableCell>
            <TableCell><strong>Name</strong></TableCell>
            <TableCell><strong>SKU</strong></TableCell>
            <TableCell><strong>Price</strong></TableCell>
            <TableCell><strong>Stock</strong></TableCell>
            <TableCell><strong>Actions</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {variations && variations.length > 0 ? (
            variations.map((variation, index) => (
              <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#fafafa' } }}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{variation.attribute}</TableCell>
                <TableCell>{variation.name}</TableCell>
                <TableCell>{variation.sku}</TableCell>
                <TableCell>₹{variation.price}</TableCell>
                <TableCell>{variation.stock}</TableCell>
                <TableCell>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => onEditVariation(variation)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => onDeleteVariation(variation.product_variant_id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                <Typography variant="body1" color="text.secondary">
                  No variations available.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProductVariationList;
